<template>
  <block
    component-name="block-text-chapter-media"
    body-class="relative top-0 left-0 grid grid-cols-12 gap-x-ui gap-y-3xl"
  >
    <template v-slot:default="blockData">
      <wrapper-reveal
        reveal="unveil-from-right"
        class="flex items-center w-full col-span-full laptop:row-start-1 laptop:row-end-2"
        :class="{
          'laptop:col-start-2 laptop:col-end-7': !$attrs.config.mediaOnRight,
          'laptop:col-start-7 laptop:col-end-12': $attrs.config.mediaOnRight,
        }"
      >
        <media
          tag="div"
          v-if="$attrs.data.body.asset"
          v-bind="$attrs.data.body.asset"
          :loading="blockData?.loading || 'eager'"
          :sizes="{
            base: 600,
            phablet: 1000,
            tablet: 1250,
            laptop: 600,
            desktop: 750,
            extdesktop: 1000,
          }"
          class="w-full"
        />
      </wrapper-reveal>

      <div
        class="flex flex-col justify-center w-full item-stretch col-span-full phablet:col-start-2 phablet:col-end-12 laptop:row-start-1 laptop:row-end-2"
        :class="{
          'laptop:col-start-8 laptop:col-end-12': !$attrs.config.mediaOnRight,
          'laptop:col-start-2 laptop:col-end-6': $attrs.config.mediaOnRight,
        }"
      >
        <txt-chapter
          :overline="$attrs.data.body.overline || undefined"
          :title="$attrs.data.body.title"
          :text="$attrs.data.body.text || undefined"
          :button="$attrs.data.body.button || undefined"
          class="w-full"
        />
      </div>
    </template>
  </block>
</template>
